import type { ReactNode } from 'react'

interface FoilFrameProps {
  children: ReactNode
  className?: string
}

function FoilFrame({ children, className = '' }: FoilFrameProps) {
  return (
    <div className={`relative rounded-[26px] p-[4px] foil-shimmer bg-gradient-to-br from-[#FF1A1A] via-[#3B4CCA] to-[#FFDE00] shadow-[8px_8px_0_rgba(0,0,0,0.45)] transition-transform duration-300 hover:-translate-y-1 hover:rotate-1 ${className}`}>
      <div className="h-full overflow-hidden rounded-[22px] bg-[#0b0b0b]">
        {children}
      </div>
    </div>
  )
}

export default FoilFrame
